import VersionRepository from './version.repository'

export default {
  version: VersionRepository,
}
